/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface OrcidPutCodeDTO
 */
export interface OrcidPutCodeDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrcidPutCodeDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OrcidPutCodeDTO
     */
    putCode?: number;
}

/**
 * Check if a given object implements the OrcidPutCodeDTO interface.
 */
export function instanceOfOrcidPutCodeDTO(value: object): value is OrcidPutCodeDTO {
    return true;
}

export function OrcidPutCodeDTOFromJSON(json: any): OrcidPutCodeDTO {
    return OrcidPutCodeDTOFromJSONTyped(json, false);
}

export function OrcidPutCodeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrcidPutCodeDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'putCode': json['putCode'] == null ? undefined : json['putCode'],
    };
}

export function OrcidPutCodeDTOToJSON(json: any): OrcidPutCodeDTO {
    return OrcidPutCodeDTOToJSONTyped(json, false);
}

export function OrcidPutCodeDTOToJSONTyped(value?: OrcidPutCodeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'putCode': value['putCode'],
    };
}


